import { createFileRoute } from "@tanstack/react-router";

import AddAccount6 from "@/features/onboarding/AddAccount6";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-account-6")({
  component: () => (
    <BasicLayout>
      <AddAccount6 />
    </BasicLayout>
  ),
});
